import { print } from 'graphql'
import { Customer } from 'shopify-types'

import { storefrontClient } from '..'
import { CreateCustomerDocument, type CreateCustomerMutation } from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCustomerToCustomer } from './graphql'

export type CreateCustomerInput = Readonly<{
  acceptsMarketing: boolean
  email: string
  firstName: string
  lastName: string
  phone: string
  password: string
}>

export const createCustomer =
  (options: GlobalRequestOptions) =>
  async (input: CreateCustomerInput): Promise<Customer> => {
    const response = await storefrontClient.request<CreateCustomerMutation>(
      print(CreateCustomerDocument),
      {
        variables: {
          input,
          language: options.language,
        },
      },
    )

    const payload = response.data?.customerCreate

    if (!payload?.customer) {
      throw new Error('Failed to create customer')
    }

    return mapGQLCustomerToCustomer(payload.customer)
  }
